/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// utils

// material
import { Page, Content} from '@insticator/insticator-ui';
import PageHeader from '../../../material/structure/pageheader/pageheader';
import PageContent from '../../../material/structure/pagecontent/pagecontent';


// styles
import injectSheet from 'react-jss';
import styles from './company_styles';

// components
import AuthenticationConfig from "./authentication/authentication";

/* ========== ~~~~~~~~~~ PROFILE - COMPANY PAGE ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {

    const { mocked } = useSelector(state => state.session);

    return (
        <Page name={'companysettingspage'} klass={`${props.classes.companysettingspage}`} >
            <Content>
                <PageHeader title={'Settings'} subtitle={'Company'} />
                <PageContent>
                    {mocked && <AuthenticationConfig/>}
                </PageContent>
            </Content>
        </Page>
    );
});
